export const LOGO_URL = "https://customer-assets.emergentagent.com/job_5b507e1c-bf44-420e-878d-cde61c04be26/artifacts/0mj0i30f_100684b4-2ee5-49d4-b617-8020dd03666a.jpg";

export const HERO_IMG = "https://images.unsplash.com/photo-1691139601099-932c01ec198b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlJTIwcHJvZmVzc2lvbmFscyUyMGhvc3BpdGFsJTIwd29ya2luZyUyMHRvZ2V0aGVyfGVufDB8fHx8MTc4MTEwODEwMXww&ixlib=rb-4.1.0&q=85";

export const CARE_IMG = "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxudXJzZSUyMGhlbHBpbmclMjBlbGRlcmx5JTIwcGF0aWVudCUyMGhvbWUlMjBjYXJlfGVufDB8fHx8MTc4MTEwODEwMXww&ixlib=rb-4.1.0&q=85";

export const TECH_IMG = "https://images.unsplash.com/photo-1666886573531-48d2e3c2b684?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwcHJvZmVzc2lvbmFscyUyMGhvc3BpdGFsJTIwd29ya2luZyUyMHRvZ2V0aGVyfGVufDB8fHx8MTc4MTEwODEwMXww&ixlib=rb-4.1.0&q=85";

export const POSITIONS = [
  { code: "RN", name: "Registered Nurse" },
  { code: "RPN", name: "Registered Practical Nurse" },
  { code: "PSW", name: "Personal Support Worker" },
  { code: "HCA", name: "Healthcare Aide" },
  { code: "CGV", name: "Caregiver" },
  { code: "MOA", name: "Medical Office Assistant" },
  { code: "MR", name: "Medical Receptionist" },
  { code: "UC", name: "Unit Clerk" },
  { code: "PTA", name: "Physiotherapy Assistant" },
  { code: "OTA", name: "Occupational Therapy Assistant" },
  { code: "REHAB", name: "Rehabilitation Assistant" },
  { code: "DA", name: "Dental Assistant" },
  { code: "DH", name: "Dental Hygienist" },
  { code: "SW", name: "Social Worker" },
];

export const POSITION_NAMES = [
  "Registered Nurse", "Registered Practical Nurse", "Personal Support Worker",
  "Healthcare Aide", "Caregiver", "Medical Office Assistant", "Medical Receptionist",
  "Unit Clerk", "Physiotherapy Assistant", "Occupational Therapy Assistant",
  "Rehabilitation Assistant", "Dental Assistant", "Dental Hygienist", "Social Worker",
];

export const SHIFT_TYPES = ["Day", "Evening", "Night", "Weekend", "Holiday"];

export const URGENCY_LEVELS = [
  { value: "standard", label: "Standard", color: "#64748B" },
  { value: "urgent", label: "Urgent", color: "#F59E0B" },
  { value: "emergency", label: "Emergency", color: "#DC2626" },
];

export const STATUS_COLOR = {
  draft: { bg: "#F1F5F9", fg: "#475569" },
  submitted: { bg: "#E0F2FE", fg: "#0369A1" },
  under_review: { bg: "#FEF3C7", fg: "#92400E" },
  proposal_sent: { bg: "#DBEAFE", fg: "#1E40AF" },
  proposal_approved: { bg: "#D1FAE5", fg: "#065F46" },
  broadcasting: { bg: "#FEF3C7", fg: "#92400E" },
  partially_filled: { bg: "#FED7AA", fg: "#9A3412" },
  fully_filled: { bg: "#D1FAE5", fg: "#065F46" },
  in_progress: { bg: "#CFFAFE", fg: "#155E75" },
  completed: { bg: "#DCFCE7", fg: "#166534" },
  cancelled: { bg: "#FEE2E2", fg: "#991B1B" },
  pending: { bg: "#FEF3C7", fg: "#92400E" },
  accepted: { bg: "#D1FAE5", fg: "#065F46" },
  declined: { bg: "#FEE2E2", fg: "#991B1B" },
  sent: { bg: "#DBEAFE", fg: "#1E40AF" },
  paid: { bg: "#DCFCE7", fg: "#166534" },
  overdue: { bg: "#FEE2E2", fg: "#991B1B" },
  approved: { bg: "#D1FAE5", fg: "#065F46" },
  rejected: { bg: "#FEE2E2", fg: "#991B1B" },
  worker_submitted: { bg: "#DBEAFE", fg: "#1E40AF" },
  facility_approved: { bg: "#FED7AA", fg: "#9A3412" },
  admin_approved: { bg: "#DCFCE7", fg: "#166534" },
  open: { bg: "#FEF3C7", fg: "#92400E" },
  investigating: { bg: "#DBEAFE", fg: "#1E40AF" },
  resolved: { bg: "#DCFCE7", fg: "#166534" },
  checked_in: { bg: "#CFFAFE", fg: "#155E75" },
  checked_out: { bg: "#DCFCE7", fg: "#166534" },
  confirmed: { bg: "#D1FAE5", fg: "#065F46" },
  no_show: { bg: "#FEE2E2", fg: "#991B1B" },
};
